<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <section *ngIf="item">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <app-tab-group>
                        <app-tab tabTitle="Gebruiker details" [borderless]="true" [showEditButton]="true"
                            (editButtonClicked)="open(content)">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <td class="text-muted" width="20">Naam</td>
                                        <td>{{item['name']}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-muted">E-mail</td>
                                        <td>{{item['email']}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-muted">School</td>
                                        <td>{{item['organisation']['name']}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </app-tab>
                        <app-tab tabTitle="EDU-V" [borderless]="true" [showEditButton]="true"
                            (editButtonClicked)="open(content)">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <td class="text-muted" width="20">EDU-V</td>
                                    </tr>
                                    <tr>
                                        <td><textarea style="height:300px;width:100%;padding:15px;">{{formatJson(eduvData)}}</textarea></td>
                                    </tr>
                                    <tr>
                                        <td><span class="" (click)="getEduV()">GET</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </app-tab>
                        <app-tab tabTitle="Licenties" [showAddButton]="true" (addButtonClicked)="addLicense()">
                            <div class="card-body card-table">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Naam</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let userLicense of userLicences">
                                            <td>
                                                {{userLicense['license']['title']}}
                                            </td>
                                            <td>
                                                {{userLicense['activated_at'] | dutchDate}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </app-tab>
                        <app-tab tabTitle="Entitlements">
                            <div class="card-body card-table">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Naam</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let entitlementCode of entitlementCodes">
                                            <td>
                                                {{entitlementCode['id']}}
                                            </td>
                                            <td>
                                                <span *ngIf="entitlementCode['portal_client']">{{entitlementCode['portal_client']['name']}}</span>
                                                <span *ngIf="!entitlementCode['portal_client']">Geen portal</span>
                                            </td>
                                            <td>
                                                {{entitlementCode['url_status']}}
                                            </td>
                                            <td>
                                                {{entitlementCode['entitlement']['id']}} 
                                                <span title="Code toevoegen" (click)="openAddCode(contentAddToken, entitlementCode['entitlement']['id'])">+</span>&nbsp;&nbsp;
                                                <span title="Entitlement bekijken" (click)="openPreview(preview, entitlementCode['entitlement']['id'])">P</span>&nbsp;&nbsp;
                                                <span title="Entitlement EDUV syncen" (click)="syncEntitlement(entitlementCode['entitlement']['id'])">S</span>&nbsp;&nbsp;
                                                <span title="Redeem entitlement" (click)="redeemEntitlement(entitlementCode['entitlement']['id'], entitlementCode['id'])">R</span>&nbsp;&nbsp;
                                                <span title="Entitlement block" (click)="blockEntitlement(entitlementCode['entitlement']['id'])">B</span>&nbsp;&nbsp;
                                            </td>
                                            <td>
                                                {{entitlementCode['entitlement']['title']}}
                                            </td>
                                            <td>
                                                {{entitlementCode['entitlement']['ean']}}
                                            </td>
                                            <td>
                                                {{entitlementCode['entitlement']['status']}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </app-tab>
                        <app-tab tabTitle="Rol" [showSaveButton]="true" (saveButtonClicked)="saveRole()">
                            <div class="card-body card-table">
                                <div class="roles-container">
                                    <p>Gebruiker rol</p>
                                    <ul>
                                        <li *ngFor="let role of getObjKeys(scopes)">
                                            <label>
                                                <input type="radio" name="role" [value]="role"
                                                    [checked]="role === selectedRole" (change)="updateRole(role)" />
                                                {{ role | titlecase }}
                                            </label>
                                        </li>
                                    </ul>
                                </div>

                                <div class="scopes-container" *ngIf="selectedRole">
                                    <p>Beschikbare scopes voor {{ selectedRole | titlecase }}</p>
                                    <ul>
                                        <li *ngFor="let scope of scopes[selectedRole]">
                                            <label>
                                                <input type="checkbox" [checked]="selectedScopes.includes(scope)"
                                                    (change)="toggleScope(scope)" />
                                                {{ scope }}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </app-tab>
                    </app-tab-group>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #preview let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Preview</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body" *ngIf="item">
        <div>
            <textarea style="width:100%;height:300px;padding:20px">{{formatJson(entitlementPreview)}}</textarea>
        </div>
    </div>
</ng-template>

<ng-template #contentAddToken let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Voeg toegang toe</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body" *ngIf="item">
        <div>
            <select class="form-control" [(ngModel)]="portalClientId">
                <ng-container *ngFor="let client of clients">
                    <option [value]="client['id']">
                        {{client['name']}}
                    </option>
                </ng-container>
            </select>
        </div>
        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="saveEntitlement()">Opslaan</button>
        </div>
    </div>
</ng-template>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Wijzig gebruiker</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body" *ngIf="item">
        <app-user-information-form [itemId]="item['id']"></app-user-information-form>
    </div>
</ng-template>